/* The Paint People: product extras (replaces VO Product Options)
   - shows colour boxes only for the variants that need them (show_when)
   - blocks Add to cart / Buy now until required colour + tick boxes are filled */
(function () {
  if (window.__tppExtras) return;
  window.__tppExtras = true;

  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function headerOffset() {
    var h = document.querySelector('[class*="shopify-section-group-header"]');
    return h && getComputedStyle(h).position === 'sticky' ? h.offsetHeight : 0;
  }
  function scrollTo(el) {
    var top = el.getBoundingClientRect().top + window.scrollY - headerOffset() - 16;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }
  function sectionOf(box) { return box.closest('.shopify-section') || document; }

  /* ---- show colour boxes only for matching option values ---- */
  function selected(box, optionName) {
    var fs = all(sectionOf(box), 'fieldset[data-option-name]').filter(function (f) {
      return f.getAttribute('data-option-name') === optionName;
    })[0];
    if (fs) { var c = fs.querySelector('input:checked'); if (c) return c.value; }
    var sel = all(sectionOf(box), 'select').filter(function (s) {
      var l = s.closest('[data-option-name]'); return l && l.getAttribute('data-option-name') === optionName;
    })[0];
    return sel ? sel.value : null;
  }
  function syncVisibility() {
    all(document, '[data-tpp-colour][data-show-option]').forEach(function (c) {
      var vals = (c.getAttribute('data-show-values') || '').split('|');
      var cur = selected(c, c.getAttribute('data-show-option'));
      var show = cur == null || vals.indexOf(cur) > -1;
      c.hidden = !show;
      all(c, 'input').forEach(function (i) { i.disabled = !show; });
      var box = c.closest('[data-tpp-extras]');
      if (box) all(box, '[data-tpp-follow]').forEach(function (f) {
        f.hidden = !show;
        all(f, 'input').forEach(function (i) { i.disabled = !show; });
      });
    });
  }

  /* ---- validation ---- */
  function fail(group) {
    group.classList.remove('tpp-invalid'); void group.offsetWidth; group.classList.add('tpp-invalid');
    var e = group.querySelector('[data-tpp-error]'); if (e) e.hidden = false;
  }
  function clear(group) {
    group.classList.remove('tpp-invalid');
    var e = group.querySelector('[data-tpp-error]'); if (e) e.hidden = true;
  }
  function validate(box) {
    var first = null;
    all(box, '[data-tpp-colour][data-required]').forEach(function (c) {
      if (c.hidden) return;
      // Benjamin Moore landing pages: the colour search checks this itself
      if (c.classList.contains('tpp-colour--bm') && c.closest('.ppx-buy')) return;
      var filled = all(c, 'input').some(function (i) { return i.value.trim() !== ''; });
      if (filled) { clear(c); return; }
      fail(c); first = first || c;
    });
    all(box, '[data-tpp-ack]').forEach(function (a) {
      var cb = a.querySelector('input[data-tpp-required]');
      if (!cb || cb.checked) { clear(a); return; }
      fail(a); first = first || a;
    });
    if (first) {
      scrollTo(first);
      var f = first.querySelector('input:not([type=hidden])');
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 350);
      return false;
    }
    return true;
  }
  // NB: product forms contain an input named "id", so form.id returns that input. Read the attribute.
  function idOf(f) { return f && f.getAttribute ? f.getAttribute('id') : null; }
  function boxFor(target) {
    var form = target.closest('form') || (target.form && target.form.tagName === 'FORM' ? target.form : null);
    var id = idOf(form) || target.getAttribute('form');
    if (!id) { var pf = target.closest('product-form'); id = idOf(pf && pf.querySelector('form')); }
    var box = id ? document.querySelector('[data-tpp-extras][data-form="' + id + '"]') : null;
    if (!box) { var s = target.closest('.shopify-section'); box = s && s.querySelector('[data-tpp-extras]'); }
    return box || null;
  }

  /* ---- colour shade for the cart chip (Benjamin Moore colour search) ---- */
  function captureHex(box) {
    var h = box.querySelector('[data-tpp-hex]');
    if (!h) return;
    var v = '';
    var num = box.querySelector('input[name="properties[Colour Number]"]');
    if (num && num.value.trim()) {
      var i = document.querySelector('.bmx-cp-sel i');
      var bg = i && i.style.background;
      if (bg && !/gradient/.test(bg)) v = bg;
      if (!v) {
        var b = document.querySelector('.bmx-sw[aria-pressed="true"]');
        if (b && b.getAttribute('data-n') === num.value.trim()) v = b.getAttribute('data-hex') || '';
      }
    }
    h.value = v; h.disabled = !v;
  }

  /* ---- "Edit" from the cart: prefill, then replace the old line on add ---- */
  var params = new URLSearchParams(location.search);
  var EDIT = params.get('tpp_edit');
  var editDone = false;
  function prefill() {
    if (!EDIT) return;
    all(document, '[data-tpp-extras]').forEach(function (box) {
      var n = box.querySelector('input[name="properties[Colour Number]"]');
      var m = box.querySelector('input[name="properties[Colour Name]"]');
      if (n && params.get('tpp_cn') && !n.value) n.value = params.get('tpp_cn');
      if (m && params.get('tpp_cname') && !m.value) m.value = params.get('tpp_cname');
      all(box, 'input[data-tpp-required]').forEach(function (i) { i.checked = true; });
      if (!box.querySelector('.tpp-editing')) {
        var p = document.createElement('p');
        p.className = 'tpp-editing';
        p.textContent = 'Editing an item in your cart. Make your changes, then add to cart to update it.';
        box.insertBefore(p, box.firstChild);
      }
    });
    var cn = params.get('tpp_cn');
    if (cn) pickBmx(cn, 0);
    var q = params.get('tpp_qty');
    if (q) all(document, 'input[name="quantity"]').forEach(function (i) { if (!i.closest('cart-drawer, .mini-cart, #cart')) i.value = q; });
  }
  // Benjamin Moore colour search: show the colour being edited as selected
  function pickBmx(cn, tries) {
    var inp = document.querySelector('.bmx-cp-in input');
    if (!inp) { if (tries < 25) setTimeout(function () { pickBmx(cn, tries + 1); }, 200); return; }
    var d = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    d.set.call(inp, cn);
    inp.dispatchEvent(new Event('input', { bubbles: true }));
    var t = 0;
    (function wait() {
      var li = all(document, '#bmx-cp-list li[role="option"]').filter(function (l) {
        var s = l.querySelector('small');
        return s && s.textContent.trim().toUpperCase() === cn.trim().toUpperCase();
      })[0];
      if (li) ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(function (ty) { li.dispatchEvent(new MouseEvent(ty, { bubbles: true })); });
      else if (t++ < 20) setTimeout(wait, 200);
    })();
  }
  function guard(e) {
    var t = e.target;
    if (!t.closest) return;
    var btn = e.type === 'submit' ? t : t.closest('.button-add-to-cart, [name="add"], .shopify-payment-button__button, shopify-buy-it-now-button, [data-shopify="payment-button"]');
    if (!btn) return;
    if (btn.closest('cart-drawer, .mini-cart, #cart, .cart-items')) return;
    if (btn.closest('sticky-cart')) return; // the sticky bar presses the main button, which is checked here
    var box = boxFor(btn);
    if (box && !validate(box)) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (box) captureHex(box);
    if (EDIT && !editDone) {
      e.preventDefault(); e.stopImmediatePropagation();
      editDone = true;
      var go = function () { (e.type === 'submit' && btn.requestSubmit) ? btn.requestSubmit() : btn.click(); };
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: EDIT, quantity: 0 }) })
        .then(go, go);
    }
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);

  document.addEventListener('input', function (e) {
    var g = e.target.closest && e.target.closest('[data-tpp-colour],[data-tpp-ack]');
    if (g && g.classList.contains('tpp-invalid')) {
      var ok = g.hasAttribute('data-tpp-ack')
        ? !!g.querySelector('input:checked')
        : all(g, 'input').some(function (i) { return i.value.trim() !== ''; });
      if (ok) clear(g);
    }
  });
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('[data-tpp-ack]')) {
      var a = e.target.closest('[data-tpp-ack]'); if (e.target.checked) clear(a);
    }
    if (e.target.type === 'radio' || e.target.tagName === 'SELECT') setTimeout(syncVisibility, 50);
  });
  document.addEventListener('product:variant-change', function () { setTimeout(syncVisibility, 50); });
  /* ---- delivery-date widget (S: Estimated Delivery Date): keep it out of the price area,
     which the theme rebuilds on every option change ---- */
  function rescueEdd() {
    var w = document.querySelector('[id^="price-"] .ot-estimated-shipping');
    if (!w) return;
    var price = w.closest('[id^="price-"]');
    // the whole price block is swapped on option change, so sit just after it
    var anchor = price.closest('.variant-changed-update') || price;
    var holder = document.getElementById('tpp-edd-holder');
    if (!holder || holder.closest('.variant-changed-update')) {
      if (holder) holder.remove();
      holder = document.createElement('div');
      holder.id = 'tpp-edd-holder';
      holder.className = 'product-block';
      holder.style.marginTop = '1.2rem';
      var pf = document.querySelector('.product-info-wrap product-form');
      if (pf) pf.parentNode.insertBefore(holder, pf.nextSibling);
      else anchor.parentNode.insertBefore(holder, anchor.nextSibling);
    }
    while (holder.firstChild) holder.removeChild(holder.firstChild);
    holder.appendChild(w);
  }
  var eddTimer = null;
  new MutationObserver(function () {
    if (eddTimer) return;
    eddTimer = setTimeout(function () { eddTimer = null; rescueEdd(); }, 30);
  }).observe(document.documentElement, { childList: true, subtree: true });
  function init() { prefill(); syncVisibility(); rescueEdd(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
   /* instant option feedback: show the tapped choice right away (the theme confirms it a moment later) */
   document.addEventListener('change', function (e) {
     var i = e.target; if (!i || i.type !== 'radio') return;
     var fs = i.closest('fieldset[data-option-name]'); if (!fs) return;
     fs.querySelectorAll('input.checked').forEach(function (x) { if (x !== i) x.classList.remove('checked'); });
     i.classList.add('checked');
     var v = fs.querySelector('.tpp-legend-value'); if (v) v.textContent = ': ' + i.value;
   }, true);
   /* TPP: save the colour hex on every paint add so cart + order emails can show the colour */
(function () {
  if (window.__tppHexFetch || !window.fetch) return; window.__tppHexFetch = true;
  var API = 'https://api.benjaminmoore.com/api/8e6d81077f5238aeab1a/color/FindColorsByKeyword?countryCode=en-ca&keyword=';
  var of = window.fetch;
  function getC() { try { return JSON.parse(sessionStorage.getItem('tppHex') || '{}'); } catch (e) { return {}; } }
  function look(n) {
    n = String(n || '').trim().toUpperCase(); if (!n) return Promise.resolve('');
    var c = getC(); if (n in c) return Promise.resolve(c[n]);
    var req = of.call(window, API + encodeURIComponent(n)).then(function (r) { return r.json(); }).then(function (j) {
      var m = ((j && j.data) || []).filter(function (x) { return (x.number || '').toUpperCase() === n; })[0];
      var h = m && m.hex ? '#' + m.hex : '';
      var c2 = getC(); c2[n] = h; try { sessionStorage.setItem('tppHex', JSON.stringify(c2)); } catch (e) {}
      return h;
    });
    return Promise.race([req, new Promise(function (r) { setTimeout(function () { r(''); }, 1500); })]).catch(function () { return ''; });
  }
  window.fetch = function (u, o) {
    try {
      var url = typeof u === 'string' ? u : (u && u.url) || '';
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && o && o.body) {
        if (typeof FormData !== 'undefined' && o.body instanceof FormData && o.body.get('properties[Colour Number]')) {
          var fd = o.body;
          return look(fd.get('properties[Colour Number]')).then(function (h) {
            if (h) fd.set('properties[_Colour Hex]', h);
            return of.call(window, u, o);
          });
        }
        if (typeof o.body === 'string' && o.body.charAt(0) === '{') {
          var b = JSON.parse(o.body), its = b.items || [b];
          var need = its.filter(function (i) { return i && i.properties && i.properties['Colour Number']; });
          if (need.length) {
            return Promise.all(need.map(function (i) {
              return look(i.properties['Colour Number']).then(function (h) { if (h) i.properties['_Colour Hex'] = h; });
            })).then(function () {
              var o2 = {}; for (var k in o) o2[k] = o[k]; o2.body = JSON.stringify(b);
              return of.call(window, u, o2);
            });
          }
        }
      }
    } catch (e) {}
    return of.apply(this, arguments);
  };
})();